module.exports = __webpack_public_path__ + "img/background-supplier.93c0bd32.svg";